import { matchPath } from 'react-router-dom';
import auth from '../../auth';

/** Hijos de un item del menú (Menues.js usa `children`). */
export const childrenOf = (item) => item.children || [];

export const isGroup = (item) => childrenOf(item).length > 0;

/**
 * Indica si el usuario puede ver el item. Mismo criterio que usaba el Sidebar:
 * un item con permiso se muestra si el usuario lo tiene; un grupo se muestra
 * si alguno de sus hijos es visible.
 */
export const isVisible = (item) => {
    if (item.permission !== undefined && !auth.hasPermission(item.permission)) return false;
    if (isGroup(item)) return childrenOf(item).some(isVisible);
    return true;
};

export const visibleItems = (items) => (items || []).filter(isVisible);

/**
 * Indica si la url del item (o la de algún descendiente) coincide con el path.
 * En los grupos solo se miran los hijos: la url del grupo (ej. /proyectos/) no
 * es una ruta. Sin `exact` también matchea subrutas.
 */
export const containsPath = (item, path, exact = true) => {
    if (isGroup(item)) return childrenOf(item).some(child => containsPath(child, path, exact));
    return !!(item.url && matchPath(path, { path: item.url, exact }));
};

/** Primera url visible del item, recorriendo sus hijos en orden. */
export const firstUrl = (item) => {
    if (!isGroup(item)) return item.url || null;
    for (const child of visibleItems(childrenOf(item))) {
        const url = firstUrl(child);
        if (url) return url;
    }
    return null;
};

/**
 * La sección (item de primer nivel) que contiene el path actual. Primero busca
 * coincidencia exacta y después por subruta.
 */
export const findSection = (sections, path) => {
    const visibles = visibleItems(sections);
    return visibles.find(section => containsPath(section, path))
        || visibles.find(section => containsPath(section, path, false));
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/menuUtils.js